import { useApiQuery } from 'hooks/useApiQuery'

export const useGetLicensedEstablishmentsByState = (currentStateId = 0) =>
  useApiQuery({
    method: 'get',
    path: '/admin/corporate-accounts/licensed-establishments',
    queryKey: ['licensed-establishments'],
    queryArgs: {},
    requestHeaders: currentStateId
      ? { 'Current-State-Id': currentStateId.toString() }
      : undefined,
  })
